import { PlusIcon } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ReactComponent as PhotoPlaceholder } from "../../assets/ic_photo_placeholder.svg";

// BFHierarchyTable now exposes `onRowClick`, so the dedicated eye
// column is gone — clicking the row anywhere outside the photo, the
// checkbox, or the inline add button opens the item sheet in view
// mode (same as every other migrated list page).

export default function generate({
  t,
  itemsColumns,
  onAdd,
  hasAddPermission,
  onImageClick,
}) {
  const columns = [
    {
      name: "photos",
      label: t("items.items.icon"),
      options: {
        customBodyRender: (val) =>
          val.length > 0 ? (
            <div
              role="button"
              tabIndex={0}
              className="inline-block size-12 cursor-pointer overflow-hidden rounded-md"
              onClick={() => onImageClick?.(val)}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  onImageClick?.(val);
                }
              }}
              aria-label="View image gallery"
            >
              <img
                src={val[0]}
                alt="Item thumbnail"
                className="size-full rounded-md object-cover"
              />
            </div>
          ) : (
            <PhotoPlaceholder width={28} className="ml-2.5" />
          ),
      },
    },
    {
      name: "title",
      label: t("items.items.identifier"),
    },
    {
      name: "description",
      label: t("items.items.description"),
    },
    {
      name: "tags",
      label: t("items.items.tags"),
      options: {
        customBodyRender: (val) =>
          Array.isArray(val) && val.length > 0 ? (
            <div className="flex flex-wrap gap-1">
              {val.map((tag) => (
                <Badge
                  key={tag.id}
                  style={{
                    backgroundColor: tag.color ?? undefined,
                    color: tag.color ? "#fff" : undefined,
                  }}
                >
                  {tag.name}
                </Badge>
              ))}
            </div>
          ) : null,
      },
    },
  ];

  if (itemsColumns) {
    itemsColumns.forEach((key) => {
      columns.push({
        name: key,
        label: t(`items.items.extras.${key}`),
      });
    });
  }

  if (hasAddPermission) {
    columns.push({
      name: "addItem",
      label: " ",
      options: {
        customBodyRender: (_val, tableMeta) => {
          if (tableMeta.value.level >= 3) return null;
          return (
            <Button
              variant="ghost"
              size="icon"
              onClick={() => onAdd(tableMeta.value)}
              aria-label={t("items.add-item-dialog.title", "Add item")}
              className="text-primary"
            >
              <PlusIcon className="size-4" />
            </Button>
          );
        },
      },
    });
  }

  return columns;
}
